import script from "./MainView.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./MainView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainView.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./MainView.vue?vue&type=script&lang=ts&setup=true"

import "./MainView.vue.scss?vue&type=style&index=0&id=71eb797c&lang=scss&scoped=true!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./MainView.vue?vue&type=style&index=0&id=71eb797c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71eb797c"]])

export default __exports__